import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import {
  AboutMenu,
  ServiceMenu,
  PlatformMenu,
  AITechMenu,
  ESGMenu,
  RecruitMenu,
} from '../../constants/siteMenus'

const ThemeMainMenu = () => {
  return (
    <Fragment>
      <ul className="navbar-nav main-navbar mb-2 mb-lg-0 ps-1">
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownAbout">
            <span className="menu-label-nowrap">{'\uCF54\uB2F4\uC18C\uAC1C'}</span>
          </a>
          <ul className="dropdown-menu" aria-labelledby="navbarDropdownAbout">
            {AboutMenu.map((val, i) => (
              <li key={i}><Link className="dropdown-item" to={val.routerPath}>{val.name}</Link></li>
            ))}
          </ul>
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle drop-nav" href="#" id="navbarDropdownOne">
            <span className="menu-label-nowrap">{'\uC11C\uBE44\uC2A4'}</span>
          </a>
          <ul className="dropdown-menu" aria-labelledby="navbarDropdownOne">
            {ServiceMenu.map((val, i) =>
              val.children?.length ? (
                <li key={i} className="dropdown-submenu position-relative">
                  <Link className="dropdown-item" to={val.routerPath}>{val.name}</Link>
                  <ul className="dropdown-menu dropdown-menu2">
                    {val.children.map((c, j) => (
                      <li key={j}>
                        <Link className="dropdown-item" to={c.routerPath}>{c.name}</Link>
                      </li>
                    ))}
                  </ul>
                </li>
              ) : (
                <li key={i}>
                  <Link className="dropdown-item" to={val.routerPath}>{val.name}</Link>
                </li>
              ),
            )}
          </ul>
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownPlatform">
            <span className="menu-label-nowrap">{'\uD50C\uB7AB\uD3FC'}</span>
          </a>
          <ul className="dropdown-menu" aria-labelledby="navbarDropdownPlatform">
            {PlatformMenu.map((val, i) => (
              <li key={i}><Link className="dropdown-item" to={val.routerPath}>{val.name}</Link></li>
            ))}
          </ul>
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link" href="#" id="navbarDropdownTwo">
            <span className="menu-label-nowrap">{'AI\uAE30\uC220'}</span>
          </a>
          <ul className="dropdown-menu" aria-labelledby="navbarDropdownTwo">
            {AITechMenu.map((val, i) => (
              <li key={i}><Link className="dropdown-item" to={val.routerPath}>{val.name}</Link></li>
            ))}
          </ul>
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownThree">
            <span className="menu-label-nowrap">{'ESG'}</span>
          </a>
          <ul className="dropdown-menu" aria-labelledby="navbarDropdownThree">
            {ESGMenu.map((val, i) => (
              <li key={i}><Link className="dropdown-item" to={val.routerPath}>{val.name}</Link></li>
            ))}
          </ul>
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown">
            <span className="menu-label-nowrap">{'\uCC44\uC6A9'}</span>
          </a>
          <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
            {RecruitMenu.map((val, i) => (
              <li key={i}><Link className="dropdown-item" to={val.routerPath}>{val.name}</Link></li>
            ))}
          </ul>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/contact">
            <span className="menu-label-nowrap">{'\uBB38\uC758\uD558\uAE30'}</span>
          </Link>
        </li>
      </ul>
    </Fragment>
  )
}

export default ThemeMainMenu
